import AGREGAR_ENTIDAD from '@/graphql/mutations/administracion/catalogos/entidades/agregarEntidad.gql';
import ENTIDADES from '@/graphql/querys/administracion/catalogos/entidades/entidades.gql';
import ACTUALIZAR_ENTIDAD from '@/graphql/mutations/administracion/catalogos/entidades/actualizarEntidad.gql';
import REMOVER_ENTIDAD from '@/graphql/mutations/administracion/catalogos/entidades/removerEntidad.gql';

export default {
  methods: {
    async mixAgregarEntidad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: AGREGAR_ENTIDAD,
        variables: {
          entidad: this.entidad,
        },
        update: (store, { data: { agregarEntidad } }) => {
          const data = store.readQuery({ query: ENTIDADES });
          data.entidades.push(agregarEntidad);
          store.writeQuery({ query: ENTIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixActualizarEntidad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: ACTUALIZAR_ENTIDAD,
        variables: {
          id: this.entidadEditar.id,
          entidad: this.entidad,
        },
        update: (store, { data: { actualizarEntidad } }) => {
          const data = store.readQuery({ query: ENTIDADES });
          const { entidades } = data;
          const index = entidades
            .findIndex((entidad) => entidad.id === actualizarEntidad.id);
          if (index !== -1) {
            entidades.splice(index, 1, actualizarEntidad);
          }
          store.writeQuery({ query: ENTIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },

    async mixEliminarEntidad() {
      this.enviandoFormulario = true;
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: REMOVER_ENTIDAD,
        variables: {
          id: this.entidadEliminar.id,
        },
        update: (store) => {
          const data = store.readQuery({ query: ENTIDADES });
          const { entidades } = data;
          const index = entidades
            .findIndex((entidad) => entidad.id === this.entidadEliminar.id);
          if (index !== -1) {
            entidades.splice(index, 1);
          }
          store.writeQuery({ query: ENTIDADES, data });
        },
      }).then(() => {
        this.mixMensajeSuccess();
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.enviandoFormulario = false;
      this.mixEsCargando();
      this.cerrar();
    },
  },
};
